import { Card, CardContent, Typography } from "@mui/material";
import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Label,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

type BarChartMonthlySessionsVisProps = {
  size: { width: number; height: number };
  label?: { xAxisLabel: string; yAxisLabel: string };
  data: { name: string; value: number }[];
};

// Bar chart component to display monthly session hours
export const BarChartMonthlySessionsVis: React.VFC<
  BarChartMonthlySessionsVisProps
> = ({ size, label, data }: BarChartMonthlySessionsVisProps) => {
  return (
    <Card
      style={{
        width: `${size.width}px`,
        marginBottom: "1%",
        overflow: "visible",
      }}
    >
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          Monthly Mat Hours
        </Typography>
        <BarChart
          width={size.width - 32}
          height={size.height + 28}
          data={data}
          margin={{
            top: 0,
            right: 10,
            left: 10,
            bottom: 20,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            interval={2}
            angle={-90}
            dy={22}
            dx={-5}
            tick={{ fontSize: 10 }}
          />
          <YAxis>
            <Label
              angle={-90}
              value={label === undefined ? undefined : label.yAxisLabel}
              position="insideLeft"
              style={{ textAnchor: "middle" }}
            />
          </YAxis>
          <Tooltip
            labelFormatter={(name) => {
              return name;
            }}
            formatter={(value: number, name: string, props) => {
              return [value, `${label?.yAxisLabel}`];
            }}
          />
          <Bar dataKey="value" fill="#8884d8" />
        </BarChart>
      </CardContent>
    </Card>
  );
};
